'use client';

import React, { useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';

export default function FAQSection() {
  const { t } = useLanguage();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section
      id="faq"
      className="py-24 px-6 bg-[#050507] relative overflow-hidden border-t border-white/5"
      aria-label="Preguntes freqüents"
    >
      <div className="max-w-4xl mx-auto space-y-16 relative z-10">
        {/* Header */}
        <div className="text-center space-y-4">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-gold/30 bg-gold/5 text-gold text-[11px] font-bold uppercase tracking-widest">
            {t.faq.badge}
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight uppercase">
            {t.faq.title}
          </h2>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            {t.faq.sub}
          </p>
        </div>

        {/* FAQ Accordion List */}
        <div className="space-y-4">
          {t.faq.items.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={idx}
                className="rounded-2xl bg-gradient-to-b from-[#111119] to-[#09090e] border border-white/10 hover:border-gold/30 transition-all duration-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  className="w-full p-6 text-left flex items-center justify-between gap-4 focus:outline-none"
                >
                  <span className="text-base sm:text-lg font-bold text-white">
                    {item.q}
                  </span>
                  <span
                    className={`w-7 h-7 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gold font-black transition-transform duration-200 flex-shrink-0 ${
                      isOpen ? 'rotate-180 bg-gold/10 border-gold/30' : ''
                    }`}
                  >
                    ↓
                  </span>
                </button>

                {isOpen && (
                  <div className="px-6 pb-6 pt-1 text-xs sm:text-sm text-slate-300 leading-relaxed border-t border-white/5">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Direct question card */}
        <div className="p-6 rounded-2xl bg-gradient-to-r from-purple-brand/20 to-gold/10 border border-gold/30 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <div>
            <p className="text-sm font-bold text-white">{t.faq.extraQuestionTitle}</p>
            <p className="text-xs text-slate-300">{t.faq.extraQuestionText}</p>
          </div>
          <a
            href="https://wa.me/34694919757?text=Hola%2C%20tinc%20un%20dubte%20sobre%20les%20webs%20d%27Onix"
            target="_blank"
            rel="noopener noreferrer"
            className="py-2.5 px-5 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-xs uppercase tracking-wider whitespace-nowrap shadow-md transition-colors"
          >
            {t.faq.extraQuestionButton}
          </a>
        </div>
      </div>
    </section>
  );
}
